import { render, staticRenderFns } from "./ThemeCom.vue?vue&type=template&id=4aea86be&"
import script from "./ThemeCom.vue?vue&type=script&lang=js&"
export * from "./ThemeCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports